import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  CoachingReplaySummary,
  CoachingReportMomentView,
} from '@euler/model/coaching-practice';
import { RotateCcw } from 'lucide-react-native';
import { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { aiColors, tint } from '../../../../ai-suite/theme';
import { kAnchorLabels } from '../../practiceCopy';
import { ReportSection } from './ReportSection';

/** A moment worth redoing: what was said, a better line, 从这里重试. */
export const MomentCard = memo(
  ({
    moment,
    customerName,
    replay,
    onRetry,
  }: {
    moment: CoachingReportMomentView;
    customerName: string;
    /** The latest replay of this moment, when there is one. */
    replay: CoachingReplaySummary | null;
    onRetry: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ReportSection style={{ gap: rpx(12) }}>
        {moment.customerLine ? (
          <View
            style={{
              borderRadius: rpx(12),
              backgroundColor: aiColors.muted,
              paddingHorizontal: rpx(12),
              paddingVertical: rpx(10),
              gap: rpx(2),
            }}
          >
            <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
              {customerName}
            </Typography.Text>
            <Typography.Text size={rpx(14)} color={aiColors.foreground}>
              {moment.customerLine}
            </Typography.Text>
          </View>
        ) : null}
        <View style={{ gap: rpx(2) }}>
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            你当时说
          </Typography.Text>
          <Typography.Text size={rpx(12)} color={aiColors.foreground}>
            {moment.traineeLine}
          </Typography.Text>
        </View>
        <View
          style={{
            borderRadius: rpx(12),
            backgroundColor: tint(aiColors.accent, 0.6),
            padding: rpx(10),
            gap: rpx(2),
          }}
        >
          <Typography.Text
            size={rpx(11)}
            bold
            color={aiColors.accentForeground}
          >
            可以这样说
          </Typography.Text>
          <Typography.Text
            size={rpx(12)}
            color={aiColors.foreground}
            style={{ lineHeight: rpx(18) }}
          >
            {moment.betterLine}
          </Typography.Text>
        </View>
        {replay?.ended ? (
          <Typography.Text size={rpx(12)} color={aiColors.green}>
            {`已重练${
              replay.verdict ? ` · ${kAnchorLabels[replay.verdict]}` : ''
            }`}
          </Typography.Text>
        ) : null}
        <TouchableOpacity
          accessibilityRole="button"
          onPress={onRetry}
          style={{
            height: rpx(36),
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: rpx(6),
            borderRadius: rpx(10),
            borderWidth: 1,
            borderColor: aiColors.border,
            backgroundColor: aiColors.card,
          }}
        >
          <RotateCcw size={rpx(15)} color={aiColors.foreground} />
          <Typography.Text size={rpx(14)} bold color={aiColors.foreground}>
            从这里重试
          </Typography.Text>
        </TouchableOpacity>
      </ReportSection>
    );
  },
);
